// filepath: /Users/sjuul/workspace/robust-risk/frontend/src/models/apiKey.ts

export type APIKeyVendor = 'openai' | 'anthropic' | 'google' | 'cohere' | 'groq';

export interface APIKey {
  id?: number;
  vendor: APIKeyVendor;
  name: string;
  is_default: boolean;
  organization_id?: number;
  created_at?: string;
  updated_at?: string;
  masked_key?: string;
}

export interface APIKeyCreate {
  vendor: APIKeyVendor;
  name: string;
  api_key: string;
  is_default: boolean;
}

export type APIKeyUpdate = Partial<Omit<APIKey, 'id' | 'vendor' | 'organization_id' | 'created_at' | 'updated_at' | 'masked_key'>>;

export const apiKeyToAPIKeyUpdate = ({ name, is_default }: APIKey): APIKeyUpdate => ({
  name,
  is_default,
});

export const VENDOR_NAMES: Record<APIKeyVendor, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  google: 'Google',
  cohere: 'Cohere',
  groq: 'Groq',
};

